import React, { useEffect, useState } from 'react';
import { stringifyDateToISO8601 } from '../../util/dates';
import { getCreditsLabel } from '../../credits-config';
import css from './CreditsPurchaseHistory.css';
import { SecondaryButton } from '../../components';

const CreditsPurchaseHistory = ({ creditsHistoryAvailable }) => {
    const [historyItemsToShow, setHistoryItemsToShow] = useState([]);

    useEffect(() => {
        if (!creditsHistoryAvailable) return;

        setHistoryItemsToShow([...creditsHistoryAvailable].splice(0, 10));
    }, []);

    const showMoreAvailable = creditsHistoryAvailable.length > historyItemsToShow.length;

    const showMore = () => {
        setHistoryItemsToShow(prev => [
            ...prev,
            ...[...creditsHistoryAvailable].splice(prev.length, 10),
        ]);
    };

    return (
        <>
            <div className={css.creditsPurchaseHistory}>
                <h3>Historie</h3>
                <section>
                    {historyItemsToShow.map((creditItem, index) => (
                        <div key={index} className={css.creditTxItem}>
                            <p>
                                {stringifyDateToISO8601(
                                    new Date(creditItem?.rewardedAt || creditItem?.createdAt),
                                    'DD.MM.YYYY'
                                )}
                            </p>
                            <p>{getCreditsLabel(creditItem)}</p>
                            <p>
                                {!!creditItem.action ? '+' : '-'} {creditItem.total}
                            </p>
                        </div>
                    ))}
                </section>
                {showMoreAvailable && (
                    <SecondaryButton onClick={showMore} className={css.loadMoreButton}>
                        Mehr anzeigen
                    </SecondaryButton>
                )}
            </div>
            <p className={css.sidenote}>
                Einige Gutschriften oder Belastungen, z. B. bei Ablauf von Credits, werden
                möglicherweise nicht vollständig in der Historie aufgeführt.
            </p>
        </>
    );
};

export default CreditsPurchaseHistory;
